<template>
    <div>
        <v-dialog :persistent="persistent" v-model="dialog" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly" class="popups">
            <keep-alive>
                <component :is="popup" />
            </keep-alive>
        </v-dialog>
    </div>
</template>

<script>
    import Start from './Start'
    import Register from './Register'
    import Login from './Login'
    import Restore from './Restore'
    import Add from './Add'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Popups',
        data(){
            return {
                
            }
        },
        components:{
            Start,
            Register,
            Login,
            Restore,
            Add,
        },
        computed: {
            ...mapGetters(['popup']),
            persistent(){
                if( ["Start", "Login", "Register", "Restore"].indexOf(this.dialog) >=0 )
                return true
                return false
            },
            dialog: {
                get(){
                    return this.popup
                },
                set(val){              
                    !val && this.$store.commit('CLOSE_POPUP')
                }            
            },
        },      
    }
</script>

<style lang="scss">
    .v-dialog{
        font-family: Roboto;
    }
</style>